var _path, _path2, _ellipse, _ellipse2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 118,
    viewBox: "0 0 115 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.6904 44.6157C88.6904 68.6992 69.0651 88.2315 44.8452 88.2315C20.6253 88.2315 1 68.6992 1 44.6157C1 20.5323 20.6253 1 44.8452 1C69.0651 1 88.6904 20.5323 88.6904 44.6157Z",
    stroke: "#00955F",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9788 77.6099L74.0137 77.5809L74.0457 77.5488L77.6997 73.8948C78.0953 73.4992 78.7404 73.5036 79.1307 73.9046L111.977 107.653C112.362 108.049 112.351 108.681 111.953 109.064L105.041 115.713C104.644 116.094 104.012 116.085 103.627 115.692L70.4703 81.9344C70.0622 81.5188 70.0959 80.8456 70.5435 80.4726L73.9788 77.6099Z",
    stroke: "#00955F",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 29.0161,
    cy: 35.4301,
    rx: 5.2759,
    ry: 5.24891,
    fill: "#00955F"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 60.6724,
    cy: 35.4301,
    rx: 5.2759,
    ry: 5.24891,
    fill: "#00955F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3359 62.987C30.3359 62.987 34.2929 55.7698 44.1852 55.7698C54.0775 55.7698 59.3534 62.987 59.3534 62.987",
    stroke: "#00955F",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.9474f0c955d832c728664dd13b0b0ab5.svg";
export { ForwardRef as ReactComponent };